import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { TECH_STACK } from "../../data/content";

export const TechStack = () => {
  return (
    <Section id="tech">
      <SectionHeading overline={TECH_STACK.overline} title={TECH_STACK.title} />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {TECH_STACK.groups.map((g, i) => (
          <Reveal key={g.label} delay={i * 0.08} className="rounded-2xl border border-white/5 bg-white/[0.015] p-6">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand mb-5">{g.label}</div>
            <ul className="space-y-3">
              {g.items.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-white/80">
                  <span className="h-1 w-1 rounded-full bg-white/30" />
                  <span className="font-mono">{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};

export default TechStack;
